<template>
  <b-modal
    :id="`mc-modal-cancel-order-${activity?.id}`"
    ref="mc-modal"
    size="md"
    centered
    scrollable
    :title="$t('fleetTask.cancelDeliveryModal.title')"
  >
    <div class="card-body p-2">
      <p>
        <span>{{ $t('fleetTask.cancelDeliveryModal.confirmationText') }}&nbsp;</span>
        <strong>{{ activity?.delivery_order?.number }}</strong>
        <span>?</span>
      </p>

      <p>
        <span>{{ $t('fleetTask.cancelDeliveryModal.description.beforeStatus') }} </span>
        <strong>{{ $t('fleetTask.cancelDeliveryModal.description.canceledStatus') }}</strong>
        <span> {{ $t('fleetTask.cancelDeliveryModal.description.afterStatus') }}&nbsp;</span>
        <strong>{{ fleetTask?.number }}</strong>
        <span>.</span>
      </p>

      <FormulateForm
        v-model="formValues"
        name="reason-form"
        @submit="handleSubmit"
        @failed-validation="handleFailedValidation"
      >
        <FormulateInput
          type="select-resourceful"
          name="reason-id"
          trackBy="id"
          validation="required"
          :label="$t('fleetTask.cancelDeliveryModal.reasonLabel')"
          :placeholder="$t('fleetTask.cancelDeliveryModal.reasonPlaceholder')"
          :help="true"
          :optionLabelFn="({ item }) => item.reason"
          :optionsGetter="reasonGet"
          :validation-messages="{
            required: $t('global.validation.required'),
          }"
        />
      </FormulateForm>
    </div>

    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0 gap-2">
        <McButton
          variant="secondary"
          :text="$t('fleetTask.cancelDeliveryModal.action.back')"
          @click="cancel"
        />
        <McButton
          :text="$t('fleetTask.cancelDeliveryModal.action.cancelDelivery')"
          :disabled="disabled"
          @click="triggerSubmit"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'

import * as Transition from '@/services/rest-api/lib/delivery/transition'
import * as Reason from '@/services/rest-api/lib/delivery/reason'

import { EventBus } from '@/router/views/fleet-task/lib/event-bus'

export default {
  components: {
    McButton,
  },
  props: {
    activity: {
      type: Object,
      default: () => ({}),
    },
    fleetTask: {
      type: Object,
      default: () => ({}),
    },
    isLastPoint: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['transition'],
  data() {
    return {
      formValues: {},
      reasonGet: Reason.get("type eq 'CANCELED'"),
      disabled: true,
    }
  },
  watch: {
    formValues: {
      handler() {
        const reasonId = this.formValues['reason-id']

        this.disabled = reasonId === null || reasonId === undefined
      },
      deep: true,
    },
  },
  methods: {
    triggerSubmit() {
      this.$formulate.submit('reason-form')
    },
    async handleSubmit(data) {
      const payload = {
        status: 'CANCELED',
        fields: {
          canceled_reason_id: data['reason-id'],
        },
      }

      const deliveryOrderId = this.activity?.delivery_order?.id

      const res = await Transition.transition(deliveryOrderId, payload)

      if (res.status === 400) {
        this.$mcToast.error({
          component: 'McToastDynamicBody',
          props: {
            contents: [
              {
                html: `<strong>${this.activity?.delivery_order?.number}</strong>${this.$t(
                  'fleetTask.cancelDeliveryModal.toast.failed'
                )}`,
              },
            ],
          },
        })
        this.$refs['mc-modal'].hide()
        return
      }

      this.$mcToast.success({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            {
              html: `<strong>${this.activity?.delivery_order?.number}</strong>${this.$t(
                'fleetTask.cancelDeliveryModal.toast.success'
              )}`,
            },
          ],
        },
      })

      if (this.isLastPoint && this.fleetTask.auto_end_type === 'ACTIVITIES_COMPLETION') {
        this.$mcToast.success({
          component: 'McToastDynamicBody',
          props: {
            contents: [
            {
              html: `<strong>${this.fleetTask?.number}</strong>${this.$t(
                'fleetTask.cancelDeliveryModal.toast.autoCompleted'
              )}`,
            },
          ],
        },
        })
      }

      this.$refs['mc-modal'].hide()
      EventBus.$emit('refetch-sequence')
    },
    handleFailedValidation(_field) {
      this.$mcToast.error(this.$t('fleetTask.cancelDeliveryModal.toast.invalidInput'))
    },
    show() {
      this.$refs['mc-modal'].show()
    },
    hide() {
      this.$refs['mc-modal'].hide()
    },
  },
}
</script>

<style>
.__transition-icon {
  font-size: 20px;
  vertical-align: middle;
  margin: 0 10px;

  &::before {
    color: #4a90e1;
  }
}

strong {
  font-weight: 600;
}
</style>
